import { render, staticRenderFns } from "./broker-name.vue?vue&type=template&id=2c39c0be"
import script from "./broker-name.vue?vue&type=script&lang=js"
export * from "./broker-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports